module.exports = __webpack_public_path__ + "img/activity2_2024.ffb01ee0.png";